import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'
import { Link } from 'react-router-dom'
import { AudioLines, CreditCard } from 'lucide-react'
import * as ROUTES from 'constants/routes'
import { Header } from 'components/Header'
import { AccordionCard } from 'components/AccordionCard'

export const Dayforce = () => {
  return (
    <>
      <Header title="Dayforce" />
      <Box margin={3}>
        <Flex gap={3} flexWrap="wrap">
          <Link
            to={ROUTES.DAYFORCE_BOOKINGS}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <AudioLines size={14} />
                  <Text fontSize={2} color="lightText">
                    Dayforce Bookings
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Search for Dayforce bookings are their related WorkWhile shifts.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.DAYFORCE_JOBS_ISSUES}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <AudioLines size={14} />
                  <Text fontSize={2} color="lightText">
                    Dayforce Jobs Issues
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                List of issues that need manual human intervention for shifts
                from Dayforce customers.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.DAYFORCE_WEBHOOKS}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <CreditCard size={14} />
                  <Text fontSize={2} color="lightText">
                    Dayforce Webhooks
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                List of webhooks received by the Dayforce integration.
              </Text>
            </AccordionCard>
          </Link>
        </Flex>
      </Box>
    </>
  )
}
